module.exports = __webpack_public_path__ + "static/media/pasta_280_gr.2a3f33e9.png";